import React, { useContext, useEffect, useMemo, useRef } from 'react'
import ReportContent from '../../component/tableDrawer/reportContent'
import ReportHeader from '../../component/tableDrawer/reportHeader'
import { AcceptProvider, GetAllProvider, RejectProvider } from '../../api/endpoints'
import BaseBtn from '../../component/tableDrawer/Tables/Components/TableActions/BaseBtn'
import { useUpdate } from '../../api/hooks'
import { useNavigate } from 'react-router-dom'
import { DomainContext } from '../../context/DomainContext'
import { PROVIDER_REQUEST_STATUS } from '../../data/Constant'
import ReportSearch from '../../component/tableDrawer/reportSearch'
import ActionBtn from '@/component/ActionBtn'

const Pending = ({ columns, TabsSection }) => {

    const openInsertModal = useRef()
    const { setCustomSearchData } = useContext(DomainContext)


    const { onUpdate: onAccept } = useUpdate(AcceptProvider)
    const { onUpdate: onReject } = useUpdate(RejectProvider)

    const navigate = useNavigate()

    const tableColumns = useMemo(() => [...columns
        ,
    {
        Header: 'details',
        Cell: ({ row: { original } }) => {
            return (
                <>
                    <BaseBtn action={"show-details"} onApply={() => navigate(`/panel/request-details/${original?.id}`)} icon={"solar:eye-outline"} className="details-info" reqAction="canAdd" />
                </>
            )
        }
    }
        ,
    {
        id: 'action',
        Cell: ({ row: { original } }) => {
            return (
                <>
                    <ActionBtn id={original?.id} onApply={onAccept} title="accept" className="accept-btn" reqAction="canAdd" icon={"si:check-fill"} />
                    <ActionBtn id={original?.id} onApply={onReject} title="reject" className="reject-btn" reqAction="canAdd" icon={"codex:cross"} />
                </>
            )
        },
    },
    ], [])


    useEffect(() => {
        setCustomSearchData(prev => ({ ...prev, statusId: PROVIDER_REQUEST_STATUS?.Pending }))
    }, [])

    return (
        <ReportContent tableAPI={GetAllProvider} columns={tableColumns}>
            <ReportHeader ApplyAction={openInsertModal} >
                <ReportSearch />
            </ReportHeader>
            <TabsSection />

        </ReportContent>
    )
}

export default Pending